var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.772,
    height: 31,
    viewBox: "0 0 43.772 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-1065 -333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,8.039H14.664V0H0Zm5.129-5.3H9.536a1.284,1.284,0,0,1,0,2.567H5.129a1.284,1.284,0,0,1,0-2.567Z",
    transform: "translate(1079.554 348.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M43.351.333a1.284,1.284,0,0,0-1.813.088l-6.47,7.136H8.7L2.234.421a1.284,1.284,0,0,0-1.9,1.725l6.519,7.19V28a3,3,0,0,0,3,3H33.925a3,3,0,0,0,3-3V9.336l6.519-7.19A1.284,1.284,0,0,0,43.351.333ZM31.786,24.582A1.284,1.284,0,0,1,30.5,25.865H13.27a1.284,1.284,0,0,1-1.284-1.284V13.975a1.284,1.284,0,0,1,1.284-1.284H30.5a1.284,1.284,0,0,1,1.284,1.284Z",
    transform: "translate(1065 333)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalProducts);
export default __webpack_public_path__ + "static/media/total-products.43f19b971bc39bfd114218b631dd90b8.svg";
export { ForwardRef as ReactComponent };